<template>
  <div class="pop-selector">
    <div
      class="pop-selector-row"
      v-for="(_, rowIndex) in 6"
      :key="'row-' + rowIndex"
    >
      <div
        @click="onValueItemClick(valueList[rowIndex * 2 + index])"
        class="pop-selector-item"
        :class="{ selected: valueList[rowIndex * 2 + index] === value }"
        v-for="(_, index) in 2"
        :key="'item-' + index"
      >
        {{ valueList[rowIndex * 2 + index] }}
      </div>
    </div>
    <div class="pop-selector-row" v-if="type === 'year'">
      <SjIcon
        iconClass="compagi_pre"
        :size="16"
        :iconSize="11"
        @click="handlePreYear"
        v-if="hasPreList"
      ></SjIcon>
      <SjIcon
        style="margin-left: auto"
        iconClass="compagi_next"
        :size="16"
        :iconSize="11"
        @click="handleNextYear"
        v-if="hasNextList"
      ></SjIcon>
    </div>
  </div>
</template>

<script>
import { CN_MONTH_LIST } from "./cnCharacter";

export default {
  name: "popSelector",
  props: {
    value: {
      required: true
    },
    type: {
      type: String // 类型year选择年， month选择月
    }
  },
  data() {
    return {
      valueCopy: this.value
    };
  },
  watch: {
    value(val) {
      if (!val || Number.parseInt(val) < 0 || Number.parseInt(val) > 9999) {
        return;
      }
      this.valueCopy = val;
    }
  },
  model: {
    prop: "value",
    event: "changeValue"
  },
  methods: {
    handlePreYear() {
      const date = new Date(this.value);
      date.setFullYear(Number.parseInt(this.valueList[0]) - 6);
      this.valueCopy = date.getTime();
    },
    handleNextYear() {
      const date = new Date(this.value);
      date.setFullYear(
        Number.parseInt(this.valueList[this.valueList.length - 1]) + 7
      );
      this.valueCopy = date.getTime();
    },
    onValueItemClick(value) {
      this.$emit("changeValue", value);
      this.$emit("change", value);
    }
  },
  computed: {
    hasPreList() {
      return Number.parseInt(this.valueList[0]) > 0;
    },

    hasNextList() {
      const date = new Date(this.valueCopy);
      return date.getFullYear() + 5 < 9999;
    },

    valueList() {
      if (this.type === "month") {
        return CN_MONTH_LIST;
      }

      const date = new Date(this.valueCopy);
      const year = date.getFullYear();
      if (year - 6 < 0) {
        return Array.from({ length: 12 }).map((v, k) => k + 0 + "");
      }

      if (year + 11 > 9999) {
        return Array.from({ length: 12 })
          .map((v, k) => 9999 - k + "")
          .reverse();
      }

      return [
        ...Array.from({ length: 6 })
          .map((v, k) => year - k - 1 + "")
          .reverse(),
        ...Array.from({ length: 6 }).map((v, k) => year + k + "")
      ];
    }
  }
};
</script>

<style scoped lang="less">
.compagi_next {
  margin-left: auto;
}
.pop-selector {
  padding: 10px 15px;
  background-color: @color-productlight;
  width: 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: @color-available;
  font-size: 12px;
  .pop-selector-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .pop-selector-item {
      width: 30px;
      text-align: center;
      padding: 5px 0;

      &.selected {
        color: @color-highlight;
      }
    }
  }
}
</style>
